<template>
  <div>
    <div
      v-if="method.client_side_gateway?.name != 'StripeConnectGateway'"
      :class="{ label: true }"
      for="payment_method_pay"
    >
      <span>{{ method.name }}</span>
      <span id="cards">
        <img
          src="@/assets/img/discover.svg"
          alt="Discover"
          v-if="method.card_types?.includes('discover')"
        />
        <img
          src="@/assets/img/jcb.svg"
          alt="JCB"
          v-if="method.card_types?.includes('jcb')"
        />
        <img
          src="@/assets/img/maestro.svg"
          alt="Maestro"
          v-if="method.card_types?.includes('maestro')"
        />
        <img
          src="@/assets/img/visa-electron.svg"
          alt="Visa Electron"
          v-if="method.card_types?.includes('visa')"
        />
        <img
          src="@/assets/img/american-express.svg"
          alt="American Express"
          v-if="method.card_types?.includes('american_express')"
        />
        <img
          src="@/assets/img/mastercard.svg"
          alt="MasterCard"
          v-if="method.card_types?.includes('master_card')"
        />
        <img
          src="@/assets/img/visa.svg"
          alt="Visa"
          v-if="method.card_types?.includes('visa')"
        />
      </span>
    </div>
    <div class="clearfix"></div>

    <transition-group name="fade">
      <StripeElementsPayment
        v-if="method.client_side_gateway?.name == 'StripeConnectGateway'"
        key="stripe-payment"
        :method="method"
      />
      <StripePayment
        v-else-if="method.client_side_gateway?.name == 'StripeJsGateway'"
        key="stripe-payment"
        :method="method"
      />
      <PayPalProPayment
        v-else-if="method.client_side_gateway?.name == 'PayPalProGateway'"
        key="paypal-pro-payment"
        :method="method"
      />
      <CreditCardPayment v-else key="credit-card-payment" :method="method" />
      <Billing
        v-if="requires.show_billing_address && gateway == 'creditcard'"
        v-show="gateway == 'creditcard'"
        key="billing-info"
      />
    </transition-group>
  </div>
</template>

<script>
import CreditCardPayment from "../payment/CreditCard";
import PayPalProPayment from "../payment/PayPalPro";
import StripePayment from "../payment/Stripe";
import StripeElementsPayment from "../payment/StripeElements";
import Billing from "../cart/Billing";

import { mapState } from "vuex";

export default {
  name: "CreditCardMethod",

  components: {
    CreditCardPayment,
    PayPalProPayment,
    StripePayment,
    StripeElementsPayment,
    Billing,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    method: {
      type: Object,
      default: function () {
        return {
          gateway: "creditcard",
          name: "Credit Card",
          client_side_gateway: null,
        };
      },
    },
  },

  computed: {
    ...mapState({
      cart: (state) => state.cart,
      requires: "requires",
    }),
    gateway: {
      get() {
        return this.$store.state.payment.gateway;
      },
      set(value) {
        this.$store.commit("setGateway", value);
      },
    },
  },
};
</script>

<style scoped>
#cards img {
  width: 8%;
  padding: 2px;
}
</style>
